// material-ui
import { makeStyles } from "@material-ui/core/styles";
import { avatarUrl, flagEmoji, playerInitials } from "helpers";
import React from "react";
// styles
import styles from "./styles";

const useStyles = makeStyles(styles);

// Circular avatar with the player's flag pinned to its lower-right edge —
// the ATP-scoreboard treatment the iOS app uses (AvatarWithFlag).
//
// Degrades in two steps, because both fields are optional on the wire and the
// image itself may not be readable: photo → initials circle → nothing but the
// flag. Renders null only when the player has neither photo, initials nor
// flag, so it never leaves an empty gap.
export default function PlayerAvatar({ player, size = 44, textColor }) {
  const classes = useStyles(styles);
  const [failed, setFailed] = React.useState(false);

  const url = avatarUrl(player);
  const flag = flagEmoji(player);
  const initials = playerInitials(player);

  // flagEmoji always returns at least the app's placeholder flag, so this
  // only bites on a player with no name and no uuid — malformed data rather
  // than a real absence.
  if (!url && !initials && !flag) return null;

  const showImage = url && !failed;

  return (
    <div
      className={classes.root}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      {showImage ? (
        <img
          className={classes.avatar}
          src={url}
          alt=""
          // A missing or unreadable object must not leave a broken-image
          // glyph on the scoreboard — fall back to the initials instead.
          onError={() => setFailed(true)}
        />
      ) : (
        <div
          className={classes.initials}
          style={{
            fontSize: size * 0.4,
            color: textColor,
            borderColor: textColor,
          }}
        >
          {initials}
        </div>
      )}
      {flag ? (
        <span className={classes.flag} style={{ fontSize: size * 0.52 }}>
          {flag}
        </span>
      ) : null}
    </div>
  );
}
